'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contactList = require('./contact-list.html');

var _contactList2 = _interopRequireDefault(_contactList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _contactList2.default,
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: function ContactListComponent() {
    'ngInject';

    _classCallCheck(this, ContactListComponent);
  }
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/contact-list/contact-list.component.js